"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const TickerLabel_1 = __importDefault(require("../../TickerLabel"));
const styled_1 = require("./styled");
const CoinWrapper_1 = __importDefault(require("../../CoinWrapper/CoinWrapper"));
const coinList = [
    {
        src: "/coins/eth.png",
        alt: "ETH",
    },
    {
        src: "/coins/matic.png",
        alt: "MATIC",
    },
];
const CoinRow = ({ callback, coin }) => {
    return (react_1.default.createElement(styled_1.Wrapper, { onClick: () => {
            callback(coin);
        } },
        react_1.default.createElement("img", { src: coin.image, alt: coin.code, height: 22, width: 22, loading: "lazy" }),
        react_1.default.createElement(styled_1.CoinName, null, coin.label),
        coin.code === 'VERSE' && (react_1.default.createElement(styled_1.CoinSection, null,
            react_1.default.createElement(CoinWrapper_1.default, { coinList: coinList }))),
        react_1.default.createElement(TickerLabel_1.default, null, coin.code)));
};
exports.default = CoinRow;
//# sourceMappingURL=CoinRow.js.map